import AreaPage from "./AreaPage";
import { CARDIFF_DATA } from "./areaData";

const CardiffPage = () => <AreaPage {...CARDIFF_DATA} />;

export default CardiffPage;
